//Core
import React from "react"

//Components
import OrderForm from "./Form"

//Styles
import style from "./style.module.scss"

const { Form, Wrapper, Title } = style

const CashNow = () => {
  return (
    <div className={Form}>
      <div className={Wrapper}>
        <h2 className={Title}>Залиште заявку на оформлення депозиту</h2>
        <OrderForm
          link={"https://tas-api.tascombank.ua/api/core/topdeposit/"}
        ></OrderForm>
      </div>
    </div>
  )
}

export default CashNow
